import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import { verifyUser } from './AuthService';  // Ensure verifyUser is defined in AuthService.js  
const VerifyEmail = ({ email, setShowVerifyPopup }) => {
    const [verificationCode, setVerificationCode] = useState(["", "", "", "", "", ""]);
    const [codeError, setCodeError] = useState(false);
    const [verificationSuccess, setVerificationSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    // ✅ Place These Functions Here
    const handleCodeChange = (index, value) => {
      if (!/^\d?$/.test(value)) return; // Only allow digits
  
      const newCode = [...verificationCode];
      newCode[index] = value;
      setVerificationCode(newCode);
  
      if (value && index < 5) {
        document.getElementById(`code-${index + 1}`).focus();
      }
    };
  
    const handleBackspace = (index, e) => {
      if (e.key === "Backspace" && index > 0 && !verificationCode[index]) {
        document.getElementById(`code-${index - 1}`).focus();
      }
    };
  
    const handleVerify = async () => {
        const code = verificationCode.join("");
    
        if (code.length !== 6) {
            setCodeError(true);
            return;
        }
    
        setLoading(true);
        setCodeError(false);
    
        try {
            const response = await verifyUser(email, code);
            console.log('Verification Response:', response); // Add this line to log the response
            
            if (response.message === "User confirmed and email verified successfully.") {
                setVerificationSuccess(true);
                // setShowVerifyPopup(false);
            } else {
                setCodeError(true);
                setVerificationCode(["", "", "", "", "", ""]);
            }
        } catch (error) {
            console.error('Verification Error:', error); // Log any errors
            setCodeError(true);
        }
    
        setLoading(false);
    };
    
  

    return (
      <div className="w-full h-full overflow-auto flex items-start justify-center pt-16">
        {/* Responsive container with appropriate max-width */}
        <div className="w-full max-w-md px-4">
          {/* Form card with scrolling for very small screens */}
          <div className="rounded-2xl backdrop-blur-md p-6 max-h-[80vh] overflow-auto" style={{
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            backgroundColor: 'var(--glass-bg)',
            boxShadow: 'var(--shadow-box)'
          }}>
            <h2 className="text-xl font-bold mb-4 text-center" style={{ color: 'var(--text-primary)' }}>Enter Verification Code</h2>
        
            {/* Error message for invalid verification code */}
            {codeError && <p className="text-red-500 text-center mb-3">❌ Invalid verification code. Try again.</p>}
        
            {/* Success message when verification is successful */}
            {verificationSuccess && (
              <p className="text-green-600 text-center font-bold">✅ Verification successful! You can now log in.</p>
            )}
        
            {/* Show 6-digit input boxes */}
            {!verificationSuccess && (
              <div className={`flex justify-center space-x-2 mt-3 ${codeError ? "animate-shake" : ""}`}>
                {verificationCode.map((digit, index) => (
                  <input
                    key={index}
                    id={`code-${index}`}
                    type="text"
                    maxLength="1"
                    className="w-12 h-12 text-center text-xl transition-all duration-150 backdrop-blur-sm rounded-2xl focus:outline-none focus:ring-2 focus:ring-cyan-400 border-0"
                    style={{
                      backdropFilter: 'blur(8px)',
                      WebkitBackdropFilter: 'blur(8px)',
                      backgroundColor: 'var(--glass-input-bg)',
                      color: 'var(--text-primary)'
                    }}
                    value={digit}
                    onChange={(e) => handleCodeChange(index, e.target.value)}
                    onKeyDown={(e) => handleBackspace(index, e)}
                    disabled={verificationSuccess || loading}
                    autoFocus={index === 0}
                    autoComplete="new-password"  // ✅ Forces the browser to stop autofilling
                    name={`otp-${index}`}  // ✅ Unique name for each input to prevent autofill history
                  />
                ))}
              </div>
            )}
        
            {/* Verify Button */}
            {!verificationSuccess && (
              <button
                onClick={handleVerify}
                className="w-full bg-primary text-white py-2 mt-4 rounded hover:bg-secondary transition"
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify"}
              </button>
            )}
        
            {/* Show "Go to Login" button only after successful verification */}
            {verificationSuccess && (
              <div className="mt-4 text-center">
                <button
                  className="w-full bg-primary text-white py-2 mt-4 rounded hover:bg-blue-600 transition"
                  onClick={() => {
                    setShowVerifyPopup(false); // ✅ Hide popup
                    navigate("/login"); // ✅ Redirect to login page
                  }}
                >
                  Go to Login
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  
};

export default VerifyEmail;
